ScoreTrekBattle.Tournament.Match = (function() {
    var _this;


    function renderPlayer(participant, isClickable) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('tournament/match/player', {
                participant: participant,
                isDeleted: participant.player.deleted ? 'yes' : 'no'
            }).then(view => {
                view.$view.toggleClass('isProPlayer', !!participant.player.pro_account);
                resolve(view.$view);
            });
        });
    }

    function renderNoPlayer() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('tournament/match/noPlayer').then(view => {
                resolve(view.$view);
            });
        });
    }

    function toggleTeamHighlight(property, $view, teamId, isActive) {
        if (!$view) {
            $view = $('body');
        }

        $view.find(`[data-team-id]`).attr(`data-${property}`, 'no');
        $view.find(`[data-team-id="${teamId}"]`).attr(`data-${property}`, isActive ? 'yes' : 'no');
    }

    _this = {
        updateTeam: function(team, $container) {
            let $team;

            if (!$container || !$container.length) {
                $container = ScoreTrekBattle.$body;
            }

            $team = $container.find(`.match-team-container [data-team-id="${team.id}"]`);

            $team.attr({
                'data-is-surrendered': (team.isSurrendered) ? 'yes' : 'no',
                'data-is-disqualified': (team.isDisqualified) ? 'yes' : 'no',
                'data-handicap': team.handicap || 0
            });

            $team.find('[data-id="teamName"]').text(team.name);
            $team.find('[data-id="teamHandicap"]').text(`${Numbers.getSign(team.handicap || 0)}${Math.abs(team.handicap) || 0}`);
        },
        renderTeam: function($referenceView, team, options) {
            return new Promise(function(resolve, reject) {
                ScoreTrekBattle.Template.render('tournament/match/team').then(view => {
                    var playerPromises;

                    options = $.extend({
                        teamSize: 1,
                        toggle: 'disabled',
                        highlight: 'no',
                        hover: 'no',
                        allowHighlight: 'no',
                        playerClickable: false,
                        isClickable: true
                    }, options);

                    playerPromises = [];

                    team.participants.forEach(participant => {
                        playerPromises.push(renderPlayer(participant, options.playerClickable));
                    });

                    while (playerPromises.length < options.teamSize) {
                        playerPromises.push(renderNoPlayer());
                    }

                    Promise.all(playerPromises).then($players => {
                        let $playersWrapper, flagInfoKey;

                        view.$view.attr({
                            'data-players-count': options.teamSize,
                            'data-is-team': (options.teamSize > 1) ? 'yes' : 'no',
                            'data-team-id': team.id,
                            'data-toggle': options.toggle,
                            'data-highlight': options.highlight,
                            'data-hover': options.hover,
                            'data-allow-highlight': options.allowHighlight,
                            'data-is-surrendered': (team.isSurrendered) ? 'yes' : 'no',
                            'data-is-disqualified': (team.isDisqualified) ? 'yes' : 'no',
                            'data-handicap': team.handicap || 0
                        });
                        
                        if (options.isClickable) {
                            view.$view.on('click', function(event) {
                                let isInDialog, isInTree;
                                if (!$referenceView) {
                                    return;
                                }

                                isInDialog = (view.$view.closest('.dialog').length > 0);
                                isInTree = (view.$view.closest('.tree-view').length > 0);

                                if (isInDialog && !isInTree) {
                                    return;
                                }

                                toggleTeamHighlight('highlight', $referenceView, this.dataset.teamId, (this.dataset.highlight !== 'yes'));
                            });
                        }

                        flagInfoKey = `tournament/team/info/${team.isDisqualified ? 'isDisqualified' : 'isSurrendered'}`;

                        view.$view.find('[data-id="teamName"]').text(team.name);
                        view.$view.find('[data-id="teamPlayers"]').empty().append($players);
                        view.$view.find('[data-id="teamHandicap"]').text(`${Numbers.getSign(team.handicap || 0)}${Math.abs(team.handicap) || 0}`);
                        view.$view.find('[data-id="teamFlag"]').attr({
                            'data-info-popup': flagInfoKey,
                            'title':  __i18n(flagInfoKey)
                        });

                        $playersWrapper = view.$view.find('[data-id="teamPlayersWrapper"]');

                        if (options.teamSize === 1) {
                            options.toggle = 'disabled';
                        }

                        if (options.toggle === 'closed') {
                            $playersWrapper.css('display', 'none');
                        }

                        if (options.toggle === 'disabled') {                     
                            view.$view.find('[data-id="teamToggle"]').removeAttr('data-trigger-action');
                        }

                        resolve(view.$view);
                    }).catch(reject);
                });
            });
        },

        renderPending: function(pendingName, options) {
            return new Promise(function(resolve, reject) {
                ScoreTrekBattle.Template.render('tournament/match/teamPending', {
                    pendingIcon: options.icon || '<i class="fa-regular fa-clock"></i>',
                    pendingName: pendingName
                }).then(view => {
                    view.$view.attr({
                        'data-players-count': options.teamSize,
                        'data-is-team': (options.teamSize > 1) ? 'yes' : 'no',
                        'data-team-id': '',
                        'data-toggle': 'disabled'
                    });
                    view.$view.find('[data-id="teamName"]').text(pendingName);
                    resolve(view.$view);
                }).catch(reject);
            });
        },

        renderTeamFrom: function(teamType, fromGame, fromGroup, useBye) {
            if (fromGame) {
                return __i18n(`player/${teamType}From`, {from: ScoreTrekBattle.Tournament.Live.getGameName(fromGame.number)});
            }

            if (fromGroup) {
                return __i18n(`player/groupWinner`, {group: ScoreTrekBattle.Tournament.Live.getGroupName(fromGroup), position: teamType});
            }

            return (useBye !== false) ? __i18n('player/bye') : '';
        }
    };

    ScoreTrekBattle.Event.on('root.click', function(event) {
        toggleTeamHighlight('hover', null, null, false);
        if (event && event.target && event.target.closest && (event.target.closest('[data-trigger-action]') !== null)) {
            return;
        }
        toggleTeamHighlight('highlight', null, null, false);
    });

    ScoreTrekBattle.Event.on('action.team.toggle', function(event) {
        let $team, dataToggle, isOpen;

        $team = $(this).closest('[data-id="team"]');

        if ($team.length === 0) {
            return;
        }

        dataToggle = $team.attr('data-toggle')

        if (dataToggle === 'disabled') {
            return;
        }

        isOpen = (dataToggle !== 'open');

        $team.attr('data-toggle', isOpen ? 'open' : 'closed');

        $team.find('[data-id="teamPlayersWrapper"]').stop()[isOpen ? 'slideDown' : 'slideUp']();
    });

    return _this;
})();

